(function () {
  console.log('[kez] hide-header-mobile.js loaded v3');

  var MOBILE_MAX = 749;
  var TOP_LOCK = 20;   // show when very near top
  var THRESHOLD = 2;   // ignore micro scroll jitter

  var lastY = window.scrollY || 0;
  var ticking = false;

  // Always re-query (Dawn swaps header DOM after load sometimes)
  var SELECTORS = [
    'header.header',                              // your fixed header
    'sticky-header',                              // Dawn wrapper
    '.shopify-section.section-header',            // header section
    '.announcement-bar-section',                  // announcement bar
    '.shopify-section-group-header-group'         // group wrapper
  ];
  function getTargets() {
    var seen = new Set();
    var out = [];
    SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (!seen.has(el)) { seen.add(el); out.push(el); }
      });
    });
    return out;
  }

  function isMobile() {
    return window.matchMedia('(max-width:' + MOBILE_MAX + 'px)').matches;
  }
  function uiIsOpen() {
    return !!document.querySelector(
      'header-drawer[open], .menu-drawer.is-open, .cart-drawer.is-open, .predictive-search[open], details[open][id*="menu"], details[open][id*="Search"]'
    );
  }

  function applyOpacity(op) {
    var hide = (op === 0);
    getTargets().forEach(function (el) {
      // make sure we always animate; inline beats theme CSS
      el.style.transition = 'opacity .28s ease';
      el.style.opacity = String(op);
      el.style.pointerEvents = hide ? 'none' : '';
      el.style.visibility = hide ? 'hidden' : '';
    });
  }
  function show() { applyOpacity(1); }
  function hide() { applyOpacity(0); }

  function onScroll() {
    if (!isMobile()) return show();
    if (uiIsOpen())  return show();

    var y = window.scrollY || 0;
    if (Math.abs(y - lastY) < THRESHOLD) return;

    var nearTop = y <= TOP_LOCK;
    var scrollingUp = y < lastY;

    // Fade OUT on scroll UP (unless near the very top); otherwise fade IN
    if (!nearTop && scrollingUp) { hide(); } else { show(); }

    lastY = y;
  }

  function rafScroll() {
    if (!ticking) {
      window.requestAnimationFrame(function () { onScroll(); ticking = false; });
      ticking = true;
    }
  }

  // Bind to multiple events (some themes use passive/touch scroll)
  window.addEventListener('scroll', rafScroll, { passive: true });
  window.addEventListener('wheel', rafScroll, { passive: true });
  window.addEventListener('touchmove', rafScroll, { passive: true });

  // Reset when viewport changes
  function reset() { show(); lastY = window.scrollY || 0; }
  window.addEventListener('resize', reset, { passive: true });
  window.addEventListener('orientationchange', reset);

  // Keep working if Dawn swaps header nodes later
  var mo = new MutationObserver(function () { /* re-run to attach inline transitions */ onScroll(); });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // Debug helpers
  window.__kezForceHide = hide;
  window.__kezForceShow = show;

  // Kick once
  onScroll();
})();
